/* eslint-disable react/forbid-prop-types */
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import KPITable from '../KPITable';

export default function RegisteredKPI({ softProducts, hardProducts, kpis }) {
  // #region Data
  const { t } = useTranslation();

  // #endregion Data
  return (
    <>
      <h4 className="mt-2">
        {t('projectProposal.researchResult.productAndResearchResultDes.softProduct.label')}
      </h4>

      {softProducts?.length > 0 && (
        <div className="form-table my-2">
          <table className="mb-2">
            <thead>
              <tr>
                <th className="text-center" style={{ minWidth: 50, width: 50 }}>
                  {t('formLayout.numericalOrder')}
                </th>
                <th className="text-center" style={{ minWidth: 220, width: 340 }}>
                  {t('submitDocument.product.productDetail.name')}
                </th>
                <th className="text-center" style={{ minWidth: 220, width: 340 }}>
                  {t('submitDocument.product.productDetail.evaluationCriteria')}
                </th>
                <th className="text-center" style={{ minWidth: 220, width: 340 }}>
                  {t('submitDocument.product.productDetail.note')}
                </th>
              </tr>
            </thead>
            <tbody>
              {softProducts?.map((item, index) => (
                <tr key={item.id}>
                  <td className="text-center">{index + 1}</td>
                  <td>{item?.name}</td>
                  <td>{item?.evaluativeCriteria}</td>
                  <td>{item?.note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <h4>{t('projectProposal.researchResult.productAndResearchResultDes.hardProduct.label')}</h4>
      {hardProducts?.length > 0 && (
        <div className="form-table my-2">
          <table className="mb-2">
            <thead>
              <tr>
                <th rowSpan={3} className="text-center" style={{ minWidth: 50, width: 50 }}>
                  {t('formLayout.numericalOrder')}
                </th>
                <th rowSpan={3} className="text-center" style={{ minWidth: 220, width: 220 }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.productName'
                  )}
                </th>
                <th rowSpan={3} className="text-center" style={{ minWidth: 200, width: 200 }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.qualityCriteria'
                  )}
                </th>
                <th rowSpan={3} className="text-center" style={{ minWidth: 80, width: 80 }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.measure'
                  )}
                </th>
                <th colSpan={3} className="text-center" style={{ minWidth: 330, width: '100%' }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.qualityLevel'
                  )}
                </th>
                <th rowSpan={3} className="text-center" style={{ minWidth: 100, width: 100 }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.expectedQuantity'
                  )}
                </th>
              </tr>
              <tr>
                <th rowSpan={2} style={{ minWidth: 80, width: 80 }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.evaluativeCriteria'
                  )}
                </th>
                <th colSpan={2}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.similarModel'
                  )}
                </th>
              </tr>
              <tr>
                <th>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.domestic'
                  )}
                </th>
                <th>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.international'
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {hardProducts?.map((item, index) => (
                <tr key={item.id}>
                  <td className="text-center">{index + 1}</td>
                  <td>{item?.name}</td>
                  <td>{item?.qualityCriteria}</td>
                  <td>{item?.measure}</td>
                  <td>{item?.evaluativeCriteria}</td>
                  <td>{item?.domesticModelQuality}</td>
                  <td>{item?.internationalModelQuality}</td>
                  <td>{item?.expectedQuantity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <h6>Danh sách KPI đã đăng ký</h6>

      <KPITable kpis={kpis} />
    </>
  );
}

RegisteredKPI.propTypes = {
  softProducts: PropTypes.array,
  hardProducts: PropTypes.array,
  kpis: PropTypes.array.isRequired,
};

RegisteredKPI.defaultProps = {
  softProducts: [],
  hardProducts: [],
};
